// src/pages/PaymentSuccess.jsx
import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Card } from "@mui/material";

export default function PaymentSuccess() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      window.location.href = "/account";
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f7fb",
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 500,
          padding: 4,
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          🎉 Payment Successful
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Your subscription has been activated. <br />
          Redirecting to your account in{" "}
          <strong>{countdown}</strong> seconds…
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ borderRadius: 2 }}
          onClick={() => (window.location.href = "/account")}
        >
          Go to My Account Now
        </Button>
      </Card>
    </Box>
  );
}
